import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../Tostador.css";
import { plotBackground } from "../../../config/colors";

export default function PerfilFrxConcentradoProducto() {
  // Objeto inicial de la peticion
  const initialFetch = Object.assign({
    idSeccion: 4,
    secuencia: 27,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  });

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  const [cuCalcina, setCuCalcina] = useState(defaultObject);
  const [sCalcina, setSCalcina] = useState(defaultObject);
  const [feCalcina, setFeCalcina] = useState(defaultObject);
  const [asCalcina, setAsCalcina] = useState(defaultObject);
  const [sio2Calcina, setSio2Calcina] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);
      //%As Concentrado por FRX

      populateCuCalcina(data);
      populateSCalcina(data);
      populateFeCalcina(data);
      populateAsCalcina(data);
      populateSio2Calcina(data);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCuCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Cu Calcina por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCuCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%S Calcina por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFeCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%Fe Calcina por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFeCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAsCalcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%As Calcina por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setAsCalcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSio2Calcina(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "%SiO2 Calcina por FRX"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSio2Calcina({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil FRX Calcina Producto"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- %Cu Calcina por FRX --------------------------------------- */}
            <Chart.Line
              name="%Cu Calcina por FRX"
              data={cuCalcina.value}
              yAxis={0}
            />

            {/** -------------------------------- %S Calcina por FRX --------------------------------------- */}
            <Chart.Line
              name="%S Calcina por FRX"
              data={sCalcina.value}
              yAxis={0}
            />

            {/** -------------------------------- %Fe Calcina por FRX --------------------------------------- */}
            <Chart.Line
              name="%Fe Calcina por FRX"
              data={feCalcina.value}
              yAxis={0}
            />

            {/** -------------------------------- %As Calcina por FRX --------------------------------------- */}
            <Chart.Line
              name="%As Calcina por FRX"
              data={asCalcina.value}
              yAxis={1}
            />

            {/** -------------------------------- %SiO2 Calcina por FRX --------------------------------------- */}
            <Chart.Line
              name="%SiO2 Calcina por FRX"
              data={sio2Calcina.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={cuCalcina.fecha} />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido Cu-Fe-S-SiO2, %"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={40}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido As, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={1}
            />

            <Chart.Tooltip valueSuffix=" % " />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
